module.exports = __webpack_public_path__ + "img/HomeEIO163.78095351.png";